//IMPORTS
import GamesHub from "./gameshub";

export const pods = {
    gamesHub: GamesHub
};
